jQuery(function ($){

    const Cookies = { accept: function (exdays) {
        const d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        const expires = 'expires=' + d.toUTCString()
        document.cookie = 'cookiesAccepted=true; path=/;' + expires
    },
    get: function (cname) {
        const name = cname + '='
        const decodedCookie = decodeURIComponent(document.cookie)
        const ca = decodedCookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    }
    }

    $('#cookie-banner').addClass('c-cookie-banner--animated')

    if(Cookies.get('cookiesAccepted') === undefined || Cookies.get('cookiesAccepted') === '') {
        $('#cookie-banner').addClass('c-cookie-banner--show')
    }

    $('#cookie-banner .c-cookie-banner__dismiss').click(function() {
        Cookies.accept()
        $('#cookie-banner').removeClass('c-cookie-banner--show')
    })

})




// WEBPACK FOOTER //
// ./src/js/cookieBanner.js